import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-Prometheus',
    templateUrl: './Prometheus.component.html'
})
export class PrometheusComponent implements OnInit {

    consumerID: string;
    data = {
        'consumerID' : this.consumerID,
        'plugin' : 'prometheus'
    };

    constructor() { }

    Prometheus() {
    }

    ngOnInit() {
    }

}
